import { Component, Input } from '@angular/core';
import { StudentReportItem } from 'src/app/components/user-dashboard/product/models/course';

@Component({
  selector: 'app-student-report-detail',
  templateUrl: './student-report-detail.component.html',
})
export class StudentReportDetailComponent {
  @Input() items: StudentReportItem[] = [];

  // Helper to determine icon/color based on type
  getItemIcon(type: string): string {
    switch (type) {
      case 'module':
        return 'folder';
      case 'subModule':
        return 'folder-open';
      case 'lesson':
        return 'file-text';
      case 'quiz':
        return 'help-circle';
      case 'assignment':
        return 'briefcase';
      default:
        return 'circle';
    }
  }

  isParent(item: StudentReportItem): boolean {
    return !!item.items && item.items.length > 0;
  }

  expandedItems = new Set<number>();

  toggleExpand(item: StudentReportItem) {
    if (this.expandedItems.has(item.id)) {
      this.expandedItems.delete(item.id);
    } else {
      this.expandedItems.add(item.id);
    }
  }

  isExpanded(item: StudentReportItem): boolean {
    return this.expandedItems.has(item.id);
  }

  getQuizDetails(item: StudentReportItem) {
    if (item.type !== 'quiz' || !item.metadata || !item.metadata.quizState)
      return null;

    const state = item.metadata.quizState;
    const answersCount = state.answers ? Object.keys(state.answers).length : 0;

    console.log(state, 'Quiz state');
    return {
      answered: answersCount,
      isStarted: state.isStarted,
      isChecked: state.isChecked,
      currentQuestion: state.currentQuestionIndex + 1,
      answers: state.answers,
      enrichedAnswers: state.answersDetailed, // Expose the new data
      score: state.score,
      passed: state.passed,
    };
  }

  getVideoDetails(item: StudentReportItem) {
    if ((item.type !== 'lesson' && item.type !== 'video') || !item.metadata)
      return null;

    const meta = item.metadata;
    const timeSpent = meta.timeSpent || 0;
    const timeSpentActive = meta.timeSpentActive || 0;
    const ratio = timeSpent > 0 ? (timeSpentActive / timeSpent) * 100 : 0;
    
    // Process videoState if exists
    let videoState = null;
    if (meta.videoState) {
      videoState = {
        ...meta.videoState,
        volume: Math.round(meta.videoState.volume || 0)
      };
    }

    return {
      timeSpent,
      timeSpentActive,
      ratio: Math.round(ratio), // Rounded percentage
      videoState: videoState,
    };
  }
}
